<!------------------------------

      Page Actions

------------------------------->
<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    [icon]="'arrowRightAlt'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.plannings"
    sbTooltip="{{ 'lang.globals.back' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    [icon]="'plannings'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.plannings"
    [pathParams]="[{id: 'planningID',value: planningID}]"
    sbTooltip="{{ 'lang.globals.planningName' |translate: { name: planning?.name } }}"
  >
  </button>

</ng-container>
<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'nav.campaigns.partialPlanningsForPlanning' | translate: {planning: planning?.name} }}"
  [itemsData]="submissions"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'partialPlannings'">

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        ID
      </th>
      <th>
        {{ 'lang.planningsList.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.creator' | translate }}
      </th>
      <th>
        {{ 'lang.globals.elements' | translate }}
      </th>
      <th>{{ 'lang.reporting.from' | translate }}</th>
      <th>{{ 'lang.reporting.till' | translate }}</th>
      <th class=" sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-submission>
    <tr>
      <td>
        {{ submission.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <sb-comp-link
            firstLine [condition]="false"
            [title]="submission.name |truncate: 60"
            [tooltip]="'lang.globals.openDetails' | translate"
            [link]="util.RoutingID.planning" [pathParams]="[{id: 'planningID', value: submission?.id}]">
          </sb-comp-link>
          <span secondLine [innerHTML]="submission.description | truncate: 80"></span>
        </sb-comp-name-wrapper>
      </td>
      <td>
        <div class="d-flex align-items-center tw-gap-3">
          <sb-icon icon="planningSubmit"></sb-icon>
          <sb-comp-display-created [data]="submission" [hideIcon]="true"></sb-comp-display-created>
        </div>
      </td>
      <td>
        <sb-comp-submission-count-display [submission]="submission"></sb-comp-submission-count-display>
      </td>
      <td>
        {{ submission.selectedFrom | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td>
        {{ submission.selectedTill | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td class="text-end sticky-col last-col tableBg">
        <div class="tw-flex tw-gap-2.5">
          <sb-split-button
            [splitButtonItems]="submission.extraSbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(submission, $event)"
          ></sb-split-button>
          <sb-split-button
            [splitButtonItems]="submission.sbButtons ?? []"
          ></sb-split-button>
          <!-- todo sublist implementation check uo if necessary
          <a *ngIf=" false && !isInModalContext" ngbTooltip="{{ 'lang.globals.openDetails' | translate }}"
             container="body" class="btn btn-primary"
             (click)="toggleSublist(submission)">
            <sb-icon *ngIf="selectedSubmission?.id !== submission?.id" [icon]="'chevronDown'"></sb-icon>
            <sb-icon *ngIf="selectedSubmission?.id === submission?.id" [icon]="'chevronUp'"></sb-icon>
          </a>-->
        </div>
      </td>
    </tr>

    @if (selectedSubmission?.id === submission?.id) {
      <tr class="row-subtable">
        <td colspan="100">
          <sb-comp-planning-commercial [submissions]="scheduledCommercials"></sb-comp-planning-commercial>
        </td>
      </tr>
    }
  </ng-template>

</sb-table-wrapper-new>
